import React from 'react'
import styles from './DocTable.module.scss'
import { fmtSize, fmtDate, fileIcon, getDocDate } from '../../utils'
import { IconEye, IconDownload, IconTrash } from '../../icons'
import Avatar from '../Avatar/Avatar'

export default function DocTable({
  docs,
  docType = 'emp',
  showOwner  = false,
  showFlags  = false,
  onToggle,
  onDelete,
  onDownload,
  onPreview,
}) {
  if (!docs) return <p className={styles.status}>Загрузка…</p>
  if (!docs.length) return <p className={styles.status}>Нет документов</p>

  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Документ</th>
            {showOwner && <th>Сотрудник</th>}
            <th>Размер</th>
            <th>Дата загрузки</th>
            {showFlags && <th>Видимость</th>}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {docs.map(doc => (
            <tr key={doc.id}>
              <td>
                <div
                  className={styles.fileCell}
                  onClick={() => onPreview?.(doc)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => e.key === 'Enter' && onPreview?.(doc)}
                >
                  <span className={styles.fileEmoji}>{fileIcon(doc.file_extension)}</span>
                  <span className={styles.fileName}>{doc.title || doc.file_name}</span>
                  {doc.file_extension && (
                    <span className={styles.extBadge}>{doc.file_extension.toUpperCase()}</span>
                  )}
                </div>
              </td>

              {showOwner && (
                <td>
                  <div className={styles.ownerCell}>
                    <Avatar src={doc.employee_photo} name={doc.employee_name} size="sm" />
                    <div className={styles.ownerInfo}>
                      <span className={styles.ownerName}>{doc.employee_name}</span>
                      {doc.employee_dept && (
                        <span className={styles.badge}>{doc.employee_dept}</span>
                      )}
                    </div>
                  </div>
                </td>
              )}

              <td className={styles.meta}>{fmtSize(doc.file_size)}</td>
              <td className={styles.meta}>{fmtDate(getDocDate(doc))}</td>

              {showFlags && (
                <td>
                  <div className={styles.flags}>
                    <button
                      className={doc.is_open ? styles.flagOn : styles.flagOff}
                      onClick={() => onToggle(doc.id, 'is_open')}
                      title="Показать в Кыргызкомур"
                    >Открыт</button>
                    <button
                      className={doc.show_in_dept ? styles.flagOn : styles.flagOff}
                      onClick={() => onToggle(doc.id, 'show_in_dept')}
                      title="Показать отделу"
                    >В отделе</button>
                    <button
                      className={doc.show_in_transit ? styles.flagOn : styles.flagOff}
                      onClick={() => onToggle(doc.id, 'show_in_transit')}
                      title="Показать всем (транзит)"
                    >Транзит</button>
                  </div>
                </td>
              )}

              <td>
                <div className={styles.actions}>
                  <button className={styles.btnPreview} onClick={() => onPreview?.(doc)} title="Предпросмотр">
                    <IconEye />
                  </button>
                  <button className={styles.btnDl} onClick={() => onDownload(docType, doc.id, doc.file_name)} title="Скачать">
                    <IconDownload />
                  </button>
                  {showFlags && (
                    <button className={styles.btnDel} onClick={() => onDelete(doc.id)} title="Удалить">
                      <IconTrash />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
